export const createEmptyEntity = () => {
  return {
    ids: [],
    entities: {},
  };
};
